import projectChecklistTaskTemplates from './project-checklist-task-templates';
import projectChecklistTaskUsers from './project-checklist-task-users';
import projectChecklistTasks from './project-checklist-tasks';
import projectChecklistTemplates from './project-checklist-templates';
import projectChecklists from './project-checklists';
import projectTemplates from './project-templates';
import projects from './projects';

let messages = Object.assign({}, projectChecklistTaskTemplates, projectChecklistTaskUsers, projectChecklistTasks, projectChecklistTemplates, projectChecklists, projectTemplates, projects);

export default messages;
